// Moved to src/utils/formatDuration.ts so the native screens share the same
// rule — they used to hand-roll the arithmetic and disagreed with each other
// (GuestHome floored, ParentPreviewPlayer rounded). Re-exported from here
// because the web screens already import it from this path.
export { videoMinutes } from "../utils/formatDuration";
